import { pgEnumFromObject } from "../../../functions/pgEnumFromObject";
import { PAYMENT_METHOD_TYPE } from "../constants/PAYMENT_METHOD_TYPE";

/**
 * @group Enums
 * 
 * @summary
 * <blockquote>PostgreSQL enum for payment method type values used in patient payment methods</blockquote>
 * 
 * @internal
 */
export const paymentMethodTypeEnum = pgEnumFromObject('payment_method_type', 
  Object.fromEntries(Object.values(PAYMENT_METHOD_TYPE).map(value => [value, value]))
);
